import {GeneralTypeModel} from '../models/general-type.model';
import {SourceTypeEnum} from './source-type.enum';

export enum UserSettingReminderFrequencyTypeEnum {
  EveryDay = 0,
  Every2Days = 1,
  EveryWeek = 2,
}

export function userSettingReminderFrequencyTypeEnumToGeneralTypeModel(type: UserSettingReminderFrequencyTypeEnum | null): GeneralTypeModel {
  switch (type) {
    case UserSettingReminderFrequencyTypeEnum.EveryDay:
      return { name: 'Every day', color: '#00a798'};
    case UserSettingReminderFrequencyTypeEnum.Every2Days:
      return { name: 'Every other day', color: '#aab900'};
    case UserSettingReminderFrequencyTypeEnum.EveryWeek:
      return { name: 'Every week', color: '#aa0000'};
    default:
      return { name: 'Unknown', color: '#7b7b7b'};
  }
}
